export default "__VITE_ASSET__Dlo$pwFG__"